import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ifc-classes"
}
const _hoisted_2 = ["title", "onClick"]

import IfcIcon from 'Core/Components/Ifc/IfcIcon.vue';

    /**
     * Inline icon-bar that lists every distinct IfcClass in the loaded model.
     * Clicking an icon toggles that class's visibility in the 3D viewport.
     *
     * Used in both the IfcImporter and the IfcEditor — the parent owns the
     * visibility state (a class → boolean map) and emits/handles the toggle by
     * calling <c>IfcViewerCore.hideByClass</c>.
     */
    
export default /*@__PURE__*/_defineComponent({
  __name: 'IfcClassVisibilityBar',
  props: {
    classes: {},
    hidden: {}
  },
  emits: ["toggle"],
  setup(__props: any) {

    

    

return (_ctx: any,_cache: any) => {
  return (__props.classes.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.classes, (cls) => {
          return (_openBlock(), _createElementBlock("button", {
            key: cls,
            class: _normalizeClass(["ifc-classes__btn", { 'ifc-classes__btn--hidden': __props.hidden[cls] }]),
            title: cls,
            onClick: ($event: any) => (_ctx.$emit('toggle', cls))
          }, [
            _createVNode(IfcIcon, {
              "ifc-class": cls,
              size: 14
            }, null, 8 /* PROPS */, ["ifc-class"])
          ], 10 /* CLASS, PROPS */, _hoisted_2))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}
}

})